import { API_TIMEOUT } from '../timeoutConfig';

export const TOKEN_RECOVERY_MAX_EXECUTIONS = 2;
export const TOKEN_RECOVERY_BACKOFF_MS = [1_000] as const;
const TOKEN_RECOVERY_COORDINATION_SLACK_MS = 2_000;
export const TOKEN_RECOVERY_EPISODE_TIMEOUT_MS =
  TOKEN_RECOVERY_MAX_EXECUTIONS * API_TIMEOUT +
  TOKEN_RECOVERY_BACKOFF_MS.reduce((total, delayMs) => total + delayMs, 0) +
  TOKEN_RECOVERY_COORDINATION_SLACK_MS;
